/* KOVA theme — header scroll, hero glow, reveal animations, toast, and a real Shopify AJAX cart */
(function () {
  // header scroll state
  var header = document.getElementById('siteHeader');
  window.addEventListener('scroll', function () {
    if (header) header.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });

  // hero cursor glow
  var hero = document.getElementById('hero');
  var glow = document.getElementById('heroGlow');
  if (hero && glow) {
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      glow.style.setProperty('--gx', ((e.clientX - r.left) / r.width * 100) + '%');
      glow.style.setProperty('--gy', ((e.clientY - r.top) / r.height * 100) + '%');
    });
    hero.addEventListener('mouseleave', function () {
      glow.style.setProperty('--gx', '50%');
      glow.style.setProperty('--gy', '36%');
    });
  }

  // scroll reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // toast helper
  var toastTimer;
  window.kovaToast = function (msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    document.getElementById('toastMsg').textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  };

  // wishlist toggle (visual only)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wish-btn');
    if (!btn) return;
    e.preventDefault();
    btn.classList.toggle('active');
  });

  /* ---------------- Cart (real Shopify AJAX Cart API) ---------------- */
  var KovaCart = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = document.getElementById('cartDrawer');
      this.overlay = document.getElementById('cartDrawerOverlay');

      document.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('submit', this.onSubmit.bind(this));
    },

    onClick: function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); this.open(); return; }

      var closer = e.target.closest('[data-cart-close]');
      if (closer) { e.preventDefault(); this.close(); return; }

      var quickAdd = e.target.closest('.quick-add');
      if (quickAdd && quickAdd.dataset.variantId) {
        e.preventDefault();
        this.addItem(quickAdd.dataset.variantId, 1, quickAdd);
        return;
      }

      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var line = qtyBtn.dataset.line;
        var dir = qtyBtn.dataset.cartQty;
        var currentQty = parseInt(qtyBtn.parentNode.querySelector('[data-qty-value]').textContent, 10);
        var newQty = dir === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
        this.updateItem(line, newQty);
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        this.updateItem(removeBtn.dataset.line, 0);
        return;
      }
    },

    onSubmit: function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      this.addItem(formData.get('id'), formData.get('quantity') || 1, submitBtn);
    },

    addItem: function (variantId, quantity, triggerEl) {
      if (!variantId) { window.kovaToast('This item is unavailable'); return; }
      if (triggerEl) triggerEl.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          if (item.status) {
            window.kovaToast(item.description || item.message || 'Could not add item');
            return;
          }
          window.kovaToast((item.product_title || item.title || 'Item') + ' added to cart');
          KovaCart.refresh(true);
        })
        .catch(function () {
          window.kovaToast('Something went wrong adding that item');
        })
        .finally(function () {
          if (triggerEl) triggerEl.disabled = false;
        });
    },

    updateItem: function (line, quantity) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () { KovaCart.refresh(false); })
        .catch(function () { window.kovaToast('Could not update cart'); });
    },

    refresh: function (openDrawer) {
      fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = doc.getElementById('cartDrawer');
          if (newDrawer && KovaCart.drawer) {
            KovaCart.drawer.innerHTML = newDrawer.innerHTML;
          }
          return fetch(window.Shopify.routes.root + 'cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          if (openDrawer) KovaCart.open();
        });
    },

    open: function () {
      if (this.drawer) this.drawer.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (this.drawer) this.drawer.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  window.Shopify = window.Shopify || {};
  window.Shopify.routes = window.Shopify.routes || { root: '/' };

  document.addEventListener('DOMContentLoaded', function () {
    KovaCart.init();
  });

  // mobile nav active state
  document.addEventListener('DOMContentLoaded', function () {
    var mnLinks = document.querySelectorAll('.mobile-nav a[href^="#"]');
    var sections = Array.prototype.map.call(mnLinks, function (a) {
      return a.getAttribute('href').replace('#', '');
    }).filter(Boolean);
    if (!sections.length) return;
    window.addEventListener('scroll', function () {
      var current = sections[0];
      sections.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 200) current = id;
      });
      mnLinks.forEach(function (a) { a.classList.remove('active'); });
      var match = document.querySelector('.mobile-nav a[href="#' + current + '"]');
      if (match) match.classList.add('active');
    }, { passive: true });
  });

  // product card: on touch devices, first tap on the image reveals the
  // second product photo instead of navigating; a second tap on the same
  // card then follows through to the product page. Desktop uses real
  // :hover for this instead, so this only intercepts on coarse/no-hover input.
  document.addEventListener('click', function (e) {
    var isTouchInput = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (!isTouchInput) return;

    var link = e.target.closest('.product-media .media-link');
    if (!link) return;

    var card = link.closest('.product-card');
    if (!card || !card.querySelector('.media-img-secondary')) return; // no second image, let it navigate normally

    if (!card.classList.contains('preview-active')) {
      e.preventDefault();
      document.querySelectorAll('.product-card.preview-active').forEach(function (c) {
        if (c !== card) c.classList.remove('preview-active');
      });
      card.classList.add('preview-active');
    }
  });

  // tapping anywhere outside a previewing card resets it
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-card.preview-active')) return;
    document.querySelectorAll('.product-card.preview-active').forEach(function (c) {
      c.classList.remove('preview-active');
    });
  });
})();